export default [
  {
    path: '/locations',
    name: 'locations',
    component: () => import('@/views/pages/record-catch/location/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.locations',
      resource: 'record_catch',
      action: 'list',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
    },
  },
  {
    path: '/locations/add',
    name: 'add-location',
    component: () => import('@/views/pages/record-catch/location/Add.vue'),
    meta: {
      pageTitle: 'breadcrumb.locations',
      resource: 'record_catch',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/locations/modify/:id',
    name: 'modify-location',
    component: () => import('@/views/pages/record-catch/location/Modify.vue'),
    meta: {
      pageTitle: 'breadcrumb.locations',
      resource: 'record_catch',
      action: 'edit',
      breadcrumb: [
        {
          text: 'breadcrumb.modify',
          active: true,
        },
      ],
    },
  },
]
